import { createAction } from 'redux-actions'

export const clearAccount = createAction('CLEAR_ACCOUNT')
export const clearContacts = createAction('CLEAR_CONTACTS')
